import { environment } from '@env/environment';

const nonce = environment.serverAuthUrl + 'dapi/defi_nonce';
const login = environment.serverAuthUrl + 'dapi/defi_login';

const stats = environment.serverUrl + 'get_total_token_stats';
const holders = environment.serverUrl + 'get_total_token_stats';
const live =  environment.serverUrl +'get_top_token_holders';
const top_sales =  environment.serverUrl + 'get_last_token_sales'

export const EXCLUDED_AUTH_API: { [key: string]: boolean } = {
   [nonce]: true,
   [login]: true,
}

export const EXCLUDED_API: { [key: string]: boolean } = {
   [stats]: true,
   [holders]: true,
   [live]: true,
   [top_sales]: true,
}

export const EXCLUDED_APIs: { [key: string]: boolean } = {
   [nonce]: true,
   [login]: true,
   [stats]: true,
   [holders]: true,
   [live]: true,
   [top_sales]: true,
}
